import { Intl } from '@erecruit/core';
import { NotificationSetting } from '@erecruit/modules';
import { UserNotificationType } from '@erecruit/types';
import { notificationTypesLocalizations } from '../../../Notifications/helpers';

export const notificationTypeValues = Object.keys(UserNotificationType)
  .filter(key => !isNaN(Number(key)))
  .map(key => Number(key));

export type NotificationTypeEntry = {
  notificationId: number;
  name: string;
  enabled: boolean;
};

export const generateNotificationTypes = (
  enabledNotifications: NotificationSetting[],
  intl: Intl.InjectedIntl,
) =>
  notificationTypeValues.reduce<NotificationTypeEntry[]>(
    (notificationTypes, currentNotificationType) => {
      return [
        ...notificationTypes,
        {
          notificationId: currentNotificationType,
          name: intl.formatMessage({
            id: notificationTypesLocalizations[currentNotificationType],
          }),
          enabled:
            enabledNotifications.find(
              x => x.notificationType === currentNotificationType,
            )?.enabled ?? true,
        },
      ];
    },
    [],
  );
